/* eslint-disable */

import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './assets/css/bootstrap.min.css'
import './assets/css/style.css'
import './assets/css/responsive.css'
import logo from './assets/images/Logo.svg'
import bookimg from './assets/images/book-favorite-img.png'
import playstorelogo from './assets/images/play-store-white.png'
import appstorelogo from './assets/images/app-store-white.png'
import appaddimg3 from './assets/images/app-add-img3.png'
import appaddimg2 from './assets/images/app-add-img2.png'
import flexibleoptionicon from './assets/images/flexible-option-icon.svg'
import instantbookingicon from './assets/images/instant-booking-icon.svg'
import exclusivediscountsicon from './assets/images/exclusive-discounts-icon.svg'
import topprofessionalsicon from './assets/images/top-professionals-icon.svg'
import securepaymentsicon from './assets/images/secure-payments-icon.svg'
import realreviewsicon from './assets/images/real-reviews-icon.svg'
import avtar1 from './assets/images/avtar1.jpg'
import avtar2 from './assets/images/avtar2.jpg'
import avtar3 from './assets/images/avtar3.jpg'
import appaddimg from './assets/images/app-add-img.png'
import playstorelogoblack from './assets/images/play-store-black.png'
import appstorelogoblack from './assets/images/app-store-black.png'
import filledstaricon from './assets/images/filled-star-icon.svg'
import unfilledstaricon from './assets/images/unfilled-star-icon.svg'
import footerlogo from './assets/images/footer-logo.png'

const Home = () => {
  const testimonials = [
    {
      name: 'Aisha Al-Fahad',
      role: 'Marketing Specialist',
      img: avtar1,
      review:
        'This app makes salon booking so easy! I love the home service option—perfect for busy days. Highly recommend!',
    },
    {
      name: 'Fahad Al-Mutairi',
      role: 'Interior Designer',
      img: avtar2,
      review:
        'No more waiting at salons! I book in seconds, get great deals, and always find top-rated professionals. Love it!',
    },
    {
      name: 'Lamia Al-Harbi',
      role: 'Software Engineer',
      img: avtar3,
      review:
        'Smooth booking, trusted salons, and amazing discounts! This app has completely changed how I schedule my beauty appointments.',
    },
    {
      name: 'Sara Al-Jabir',
      role: 'Graphic Designer',
      img: avtar3,
      review:
        "I absolutely love this app! It's so convenient to book my salon appointments, and the service is top-notch.",
    },
    {
      name: 'Lamia Al-Harbi',
      role: 'Software Engineer',
      img: avtar3,
      review:
        'Smooth booking, trusted salons, and amazing discounts! This app has completely changed how I schedule my beauty appointments.',
    },
  ]

  const CustomPrevArrow = ({ onClick }) => (
    <button className="slick-prev customer_slider_arrow" onClick={onClick}>
      &#10094;
    </button>
  )

  const CustomNextArrow = ({ onClick }) => (
    <button className="slick-next customer_slider_arrow" onClick={onClick}>
      &#10095;
    </button>
  )

  // **Add PropTypes validation**
  CustomPrevArrow.propTypes = {
    onClick: PropTypes.func,
  }

  CustomNextArrow.propTypes = {
    onClick: PropTypes.func,
  }

  const [currentSlide, setCurrentSlide] = useState(1)

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    afterChange: (index) => setCurrentSlide(index + 1),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  const newLang = localStorage.getItem('i18nextLng') ?? 'ar'

  return (
    <>
      <meta charSet="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>BNAT-App</title>

      {/* Header */}
      <header className="pt-4">
        <div className="container">
          <div className="d-flex align-items-center ">
            <a href="#" className="logo">
              <img src={logo} alt="Bnat-App" className="img-fluid" />
            </a>
            <div className="">
              <a href={`/about-us?lang=${newLang}`} className="pl-3 cursor-pointer">
                <span>About Us</span>
              </a>
              {/* <a className='pl-3 cursor-pointer'>
              <span>Partners</span>
            </a> */}
            </div>
            {/* <button className="btn_filled fw-bold text-capitalize font-18 rounded-3 contact_btn">
              Contact Us
            </button> */}
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero_section">
        <div className="container">
          <div className="row row-gap-4">
            <div className="col-lg-6">
              <div className="hero_info">
                <h1 className="text-dark-600 fw-bold font-60">
                  Book Your Favorite Salon Services in Just One Tap!
                </h1>
                <p className="mt-3">
                  Find top salons, book appointments in seconds, and enjoy premium beauty
                  services—all at your fingertips!
                </p>
                {/* <div className="mt-5 d-flex align-items-center flex-wrap row-gap-3 btn_wrapper">
                  <button className="btn_filled fw-bold text-capitalize font-18 rounded-3 me-3">
                    Get Started
                  </button>
                  <button className="btn_outline fw-bold text-capitalize font-18 rounded-3 d-flex align-items-center justify-content-center">
                    Learn More
                  </button>
                </div> */}
              </div>
            </div>
            <div className="col-lg-6">
              <figure className="m-0 hero_img">
                <img src={bookimg} alt="Bnat-App" className="img-fluid" />
              </figure>
            </div>
          </div>
        </div>
      </section>
      {/* Book-Now Section */}
      <section className="bg-pink book_now_Section">
        <div className="container">
          <div className="row row-gap-3">
            <div className="col-lg-6">
              <div className="position-relative left">
                <h2 className="text-white fw-bold font-48">
                  Bad hair days? Not on our watch— <br /> Book now, shine always!
                </h2>
                <svg
                  width={79}
                  height={80}
                  viewBox="0 0 79 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="position-absolute"
                >
                  {' '}
                  <path
                    d="M47.001 0C47.001 0 50.5347 15.169 57.1833 21.8177C63.8319 28.4663 79.001 32 79.001 32C79.001 32 63.8319 35.5337 57.1833 42.1823C50.5347 48.831 47.001 64 47.001 64C47.001 64 43.4673 48.831 36.8186 42.1823C30.17 35.5337 15.001 32 15.001 32C15.001 32 30.17 28.4663 36.8186 21.8177C43.4673 15.169 47.001 0 47.001 0Z"
                    fill="white"
                  />{' '}
                  <path
                    d="M23.2073 56.7356C23.2073 56.7356 20.3946 61.2568 20.3946 64.4712C20.3946 67.6856 23.2073 72.2068 23.2073 72.2068C23.2073 72.2068 18.6861 69.3941 15.4717 69.3941C12.2572 69.3941 7.73608 72.2068 7.73608 72.2068C7.73608 72.2068 10.5488 67.6856 10.5488 64.4712C10.5488 61.2568 7.73608 56.7356 7.73608 56.7356C7.73608 56.7356 12.2572 59.5483 15.4717 59.5483C18.6861 59.5483 23.2073 56.7356 23.2073 56.7356Z"
                    fill="white"
                  />{' '}
                </svg>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="position-relative right">
                <p className="text-gray-400 fw-semibold mb-3">
                  Say goodbye to long waits and last-minute salon stress! Book top-rated salons,
                  secure your spot in seconds, and enjoy a flawless experience—all from your phone.
                </p>
                <p className="text-gray-400 fw-semibold">
                  Download now on Play Store & App Store and let the pampering begin!
                </p>
                <div className="d-flex align-items-center gap-3 mt-5 download_app_btns">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.bnat"
                    title="Play Store"
                  >
                    <img src={playstorelogo} alt="Bnat-App" className="img-fluid" />
                  </a>
                  <a
                    href="https://apps.apple.com/us/app/bnat/id6744354017"
                    title="App Store"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={appstorelogo} alt="Bnat-App" className="img-fluid" />
                  </a>
                </div>
                <svg
                  width={79}
                  height={80}
                  viewBox="0 0 79 80"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="position-absolute"
                >
                  {' '}
                  <path
                    d="M47.001 0C47.001 0 50.5347 15.169 57.1833 21.8177C63.8319 28.4663 79.001 32 79.001 32C79.001 32 63.8319 35.5337 57.1833 42.1823C50.5347 48.831 47.001 64 47.001 64C47.001 64 43.4673 48.831 36.8186 42.1823C30.17 35.5337 15.001 32 15.001 32C15.001 32 30.17 28.4663 36.8186 21.8177C43.4673 15.169 47.001 0 47.001 0Z"
                    fill="white"
                  />{' '}
                  <path
                    d="M23.2073 56.7356C23.2073 56.7356 20.3946 61.2568 20.3946 64.4712C20.3946 67.6856 23.2073 72.2068 23.2073 72.2068C23.2073 72.2068 18.6861 69.3941 15.4717 69.3941C12.2572 69.3941 7.73608 72.2068 7.73608 72.2068C7.73608 72.2068 10.5488 67.6856 10.5488 64.4712C10.5488 61.2568 7.73608 56.7356 7.73608 56.7356C7.73608 56.7356 12.2572 59.5483 15.4717 59.5483C18.6861 59.5483 23.2073 56.7356 23.2073 56.7356Z"
                    fill="white"
                  />{' '}
                </svg>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ========== Favorite-App Section ========== */}
      <section className="favorite_app_Section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h2 className="text-dark-600 fw-bold font-48">
                Why This Salon App Will Be Your Favorite!
              </h2>
            </div>
            <div className="col-lg-6">
              <p>
                Discover easy booking,exclusive deals,and seamless salon experiences—all at your
                fingertips with our app!
              </p>
            </div>
          </div>
          {/* favorite app images frame */}
          <div className="app_image_wrapper">
            <div className="row row-gap-4">
              <div className="col-md-6">
                <div className="app_image">
                  <figure className="m-0 d-flex justify-content-center image_frame">
                    <img src={appaddimg3} alt="Bnat-App" className="img-fluid" />
                  </figure>
                  <div className="text-center mx-auto app_image_info">
                    <h3 className="text-dark-600 mb-12 fw-bold font-30">
                      Flexible Booking Options
                    </h3>
                    <p>Book your salon service at home or visit your favorite salon.</p>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="app_image">
                  <figure className="m-0 d-flex justify-content-center image_frame">
                    <img src={appaddimg2} alt="Bnat-App" className="img-fluid" />
                  </figure>
                  <div className="text-center mx-auto app_image_info">
                    <h3 className="text-dark-600 mb-12 fw-bold font-30">
                      Quick and Easy Appointments{' '}
                    </h3>
                    <p>Reserve your spot with just a few taps,no waiting!</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ========== App-feature Section ========== */}
      <section className="bg-pink app_feature_section">
        <div className="container">
          <div className="text-center mx-auto section_header">
            <h2 className="font-48 fw-bold text-white mb-3">
              Smart Features for a Seamless App Experience!
            </h2>
            <p className="font-24 text-white fw-medium mb-0">
              Discover easy booking,exclusive deals,and seamless salon experiences—all at your
              fingertips with our app!
            </p>
          </div>
          <div className="app_feature_boxes">
            <div className="row">
              <div className="col-lg-4 col-sm-6">
                <div className="text-center app_feature_box">
                  <figure className="m-0">
                    <img
                      src={flexibleoptionicon}
                      alt="Bnat-App"
                      className="img-fluid d-inline-block"
                    />
                  </figure>

                  <div className="mt-4 pt-2 app_feature_box_info">
                    <h4 className="font-30 fw-bold text-white mb-12">Flexible Options</h4>
                    <p className="text-white">Get pampered at home or visit top salons near you</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="text-center app_feature_box">
                  <figure className="m-0">
                    <img
                      src={instantbookingicon}
                      alt="Bnat-App"
                      className="img-fluid d-inline-block"
                    />
                  </figure>
                  <div className="mt-4 pt-2 app_feature_box_info">
                    <h4 className="font-30 fw-bold text-white mb-12">Instant Booking</h4>
                    <p className="text-white">Book your favorite services in just a few taps.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="text-center app_feature_box">
                  <figure className="m-0">
                    <img
                      src={exclusivediscountsicon}
                      alt="Bnat-App"
                      className="img-fluid d-inline-block"
                    />
                  </figure>
                  <div className="mt-4 pt-2 app_feature_box_info">
                    <h4 className="font-30 fw-bold text-white mb-12">Exclusive Discounts</h4>
                    <p className="text-white">
                      Unlock special offers available only for app users.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="text-center app_feature_box">
                  <figure className="m-0">
                    <img
                      src={topprofessionalsicon}
                      alt="Bnat-App"
                      className="img-fluid d-inline-block"
                    />
                  </figure>
                  <div className="mt-4 pt-2 app_feature_box_info">
                    <h4 className="font-30 fw-bold text-white mb-12">Top Professionals</h4>
                    <p className="text-white"> Choose from a trusted network of beauty experts.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="text-center app_feature_box">
                  <figure className="m-0">
                    <img
                      src={securepaymentsicon}
                      alt="Bnat-App"
                      className="img-fluid d-inline-block"
                    />
                  </figure>
                  <div className="mt-4 pt-2 app_feature_box_info">
                    <h4 className="font-30 fw-bold text-white mb-12">Secure Payments</h4>
                    <p className="text-white">
                      {' '}
                      Pay securely online or OTP for in-person payments.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="text-center app_feature_box">
                  <figure className="m-0">
                    <img
                      src={realreviewsicon}
                      alt="Bnat-App"
                      className="img-fluid d-inline-block"
                    />
                  </figure>
                  <div className="mt-4 pt-2 app_feature_box_info">
                    <h4 className="font-30 fw-bold text-white mb-12">Real Reviews</h4>
                    <p className="text-white">
                      Book with confidence using genuine customer feedback.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ========== Customer-Testimonial Section ========== */}
      {/* <section className="overflow-x-hidden overflow-y-hidden customer_testimonial">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h2 className="text-dark-600 fw-bold font-48">
                What Our Happy Customers Are Saying!
              </h2>
            </div>
            <div className="col-lg-6">
              <p>
                Hear from our happy customers! Real reviews, real experiences—see why they love
                booking salon services with our app.{' '}
              </p>
            </div>
          </div>
          <div className="customer_slider_wrapper">
            <Slider {...settings}>
              {testimonials.map((testimonial, index) => (
                <div key={index} className="customer_slide_wrapper" style={{ display: 'block' }}>
                  <div className="border-gray radius-12 p-4 bg-gray customer_slide">
                    <ul className="d-flex align-items-center rating_star_list">
                      {[...Array(4)].map((_, i) => (
                        <li key={i}>
                          <img src={filledstaricon} alt="star" />
                        </li>
                      ))}
                      <li>
                        <img src={unfilledstaricon} alt="star" />
                      </li>
                    </ul>
                    <p className="text-gray-600 font-16 fw-normal my-20">{testimonial.review}</p>
                    <div className="d-flex align-items-center gap-12 customer_info_box">
                      <figure className="mb-0">
                        <img
                          src={testimonial.img}
                          alt={testimonial.name}
                          className="img-fluid object-fit-cover rounded-pill"
                        />
                      </figure>
                      <div className="customer_info">
                        <h5 className="font-16 fw-semibold text-dark-600 mb-1">
                          {testimonial.name}
                        </h5>
                        <p className="font-14 text-gray-500 fw-normal">{testimonial.role}</p>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
            <hr className="divider" />
            <span className="font-24 text-gray-500 fw-medium slideNumber">
              {currentSlide}/{testimonials.length}
            </span>
          </div>
        </div>
      </section> */}
      {/* ========== Download-App Section ========== */}
      <section className="download_app_section">
        <div className="container">
          <div className="row row-gap-4">
            <div className="col-md-6">
              <figure className="mb-0 img_wrapper">
                <img src={appaddimg} alt="Bnat-App" />
              </figure>
            </div>
            <div className="col-md-6">
              <div className="ms-auto right">
                <h2 className="font-36 fw-bold mb-3">
                  Unlock Exclusive Deals – Your Salon App Awaits!
                </h2>
                <p>
                  Discover amazing salon deals and book effortlessly. Download now from App Store or
                  Play Store!
                </p>
                <div className="d-flex align-items-center gap-3 download_app_btns">
                  <a
                    href="https://play.google.com/store/apps/details?id=com.bnat"
                    title="Play Store"
                  >
                    <img src={playstorelogoblack} alt="Bnat-App" className="img-fluid" />
                  </a>
                  <a
                    href="https://apps.apple.com/us/app/bnat/id6744354017"
                    title="App Store"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={appstorelogoblack} alt="Bnat-App" className="img-fluid" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Footer */}
      <footer>
        <div className="container">
          <div className="row row-gap-4 footer_top">
            <div className="col-md-6 footer_top_left">
              <figure className="mb-0 img_wrapper">
                <img src={logo} alt="Bnat-App" className="img-fluid" />
              </figure>
              <p className="font-18 font-dmSans fw-normal my-2">
                Our app is a lifestyle companion for ladies, providing convenience, empowerment, and
                inspiration for every aspect of their lives.
              </p>
              <ul className="d-flex align-items-center gap-3 social_list">
                <li>
                  <a href="https://www.instagram.com/bnat.qa?igsh=MWp1cGZmbGNleWN5MA==">
                    <svg
                      width="19"
                      height="19"
                      viewBox="0 0 19 19"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {' '}
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0.849609 9.39502C0.849609 5.79988 0.849609 4.00231 1.7063 2.70757C2.08886 2.12941 2.584 1.63427 3.16216 1.25171C4.4569 0.39502 6.25447 0.39502 9.84961 0.39502C13.4447 0.39502 15.2423 0.39502 16.5371 1.25171C17.1152 1.63427 17.6104 2.12941 17.9929 2.70757C18.8496 4.00231 18.8496 5.79988 18.8496 9.39502C18.8496 12.9902 18.8496 14.7877 17.9929 16.0825C17.6104 16.6606 17.1152 17.1558 16.5371 17.5383C15.2423 18.395 13.4447 18.395 9.84961 18.395C6.25447 18.395 4.4569 18.395 3.16216 17.5383C2.584 17.1558 2.08886 16.6606 1.7063 16.0825C0.849609 14.7877 0.849609 12.9902 0.849609 9.39502ZM14.5089 9.39525C14.5089 11.9686 12.4228 14.0547 9.84945 14.0547C7.27613 14.0547 5.19004 11.9686 5.19004 9.39525C5.19004 6.82193 7.27613 4.73584 9.84945 4.73584C12.4228 4.73584 14.5089 6.82193 14.5089 9.39525ZM9.84945 12.4782C11.5521 12.4782 12.9325 11.0979 12.9325 9.39525C12.9325 7.69255 11.5521 6.31224 9.84945 6.31224C8.14675 6.31224 6.76645 7.69255 6.76645 9.39525C6.76645 11.0979 8.14675 12.4782 9.84945 12.4782ZM14.6929 5.59657C15.2975 5.59657 15.7877 5.1064 15.7877 4.50174C15.7877 3.89709 15.2975 3.40692 14.6929 3.40692C14.0882 3.40692 13.5981 3.89709 13.5981 4.50174C13.5981 5.1064 14.0882 5.59657 14.6929 5.59657Z"
                        fill="#DC46A3"
                      />{' '}
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-md-6 footer_top_right">
              <h5 className="fw-bold font-20">Contacts us</h5>
              <div className="d-flex align-items-center flex-wrap row-gap-3 contact_box">
                <a href="mailto:admin@bnatqa.com" className="font-18 fw-normal text-gray-500">
                  <svg
                    width="20"
                    height="15"
                    viewBox="0 0 20 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    {' '}
                    <path
                      d="M18.3334 2.94971V11.283C18.3334 11.8356 18.1139 12.3655 17.7232 12.7562C17.3325 13.1469 16.8026 13.3664 16.25 13.3664H3.75002C3.19749 13.3664 2.66758 13.1469 2.27688 12.7562C1.88618 12.3655 1.66669 11.8356 1.66669 11.283V2.94971"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />{' '}
                    <path
                      d="M18.3334 2.94954C18.3334 2.39701 18.1139 1.86711 17.7232 1.47641C17.3325 1.0857 16.8026 0.866211 16.25 0.866211H3.75002C3.19749 0.866211 2.66758 1.0857 2.27688 1.47641C1.88618 1.86711 1.66669 2.39701 1.66669 2.94954L8.89585 7.46343C9.22696 7.67038 9.60956 7.7801 10 7.7801C10.3905 7.7801 10.7731 7.67038 11.1042 7.46343L18.3334 2.94954Z"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />{' '}
                  </svg>

                  <span>admin@bnatqa.com</span>
                </a>
                <a href="tel:71816513" className="font-18 fw-normal text-gray-500">
                  <svg
                    width="19"
                    height="19"
                    viewBox="0 0 19 19"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    {' '}
                    <path
                      d="M11.3662 17.3851L11.3753 17.3915C12.1623 17.8926 13.0968 18.1102 14.0242 18.0084C14.9517 17.9065 15.8167 17.4913 16.4762 16.8313L17.0491 16.2584C17.1761 16.1315 17.2768 15.9808 17.3455 15.815C17.4143 15.6492 17.4496 15.4714 17.4496 15.2919C17.4496 15.1124 17.4143 14.9347 17.3455 14.7688C17.2768 14.603 17.1761 14.4524 17.0491 14.3255L14.6326 11.9107C14.5057 11.7838 14.355 11.683 14.1892 11.6143C14.0234 11.5456 13.8456 11.5102 13.6661 11.5102C13.4866 11.5102 13.3089 11.5456 13.1431 11.6143C12.9772 11.683 12.8266 11.7838 12.6997 11.9107C12.4435 12.1669 12.096 12.3108 11.7337 12.3108C11.3714 12.3108 11.0239 12.1669 10.7677 11.9107L6.90376 8.04586C6.64761 7.78963 6.50372 7.44217 6.50372 7.07987C6.50372 6.71757 6.64761 6.3701 6.90376 6.11388C7.03073 5.987 7.13145 5.83633 7.20017 5.67051C7.26889 5.50468 7.30426 5.32694 7.30426 5.14744C7.30426 4.96794 7.26889 4.79019 7.20017 4.62437C7.13145 4.45854 7.03073 4.30788 6.90376 4.18099L4.48811 1.76625C4.23188 1.51011 3.88442 1.36621 3.52212 1.36621C3.15982 1.36621 2.81235 1.51011 2.55613 1.76625L1.98227 2.33919C1.32243 2.99883 0.907364 3.86385 0.805674 4.79131C0.703985 5.71878 0.921753 6.65318 1.42299 7.44012L1.42846 7.44923C4.07564 11.3658 7.44908 14.7386 11.3662 17.3851V17.3851Z"
                      stroke="currentColor"
                      strokeWidth="1.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />{' '}
                  </svg>

                  <span>71816513</span>
                </a>
              </div>
            </div>
          </div>
          <hr className="divider opacity-100" />
          <div className="row row-gap-2 footer_bottom">
            <div className="col text-center text-md-start">
              <span className="font-18 fw-normal text-gray-500">Copyright © 2025 Bnat</span>
            </div>
            <div className="col text-center">
              <ul className="d-flex align-items-center font-18 column-gap-3 row-gap-2 flex-wrap justify-content-center fw-normal font-dmSans text-gray-500 terms_page_list">
                <li className="position-relative">All Rights Reserved</li>
                <li className="position-relative">
                  <Link to="/terms-condition">Terms and Conditions</Link>
                </li>
                <li className="position-relative">
                  <Link to="/privacy-policy">Privacy Policy</Link>
                </li>
                <li className="position-relative">
                  <Link to="/about-us">About Us</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}

export default Home
